import React, { useEffect, useState } from "react";
import { Button, Badge, Row, Col, Container} from "reactstrap";
import { Tabs, Card, Table, Drawer, Form, Input, } from "antd";

import {
    UserOutlined  } from "@ant-design/icons";
  
import { CardContent, Modal } from 'semantic-ui-react'
import { Link } from "react-router-dom";
import {Alert } from "reactstrap";
import { Firestore } from "../../config/firebase";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { Dropdown } from 'semantic-ui-react'
export default function AllUpdates() {
  const { TabPane } = Tabs;

  const [data, setData] = useState([]);
  const [accelerator, setaccelerator] = useState([])
  const [Crypto, setCrypto] = useState([])
  const [Hackathon, setHackathon] = useState([])

  const [Grants, setGrant] = useState([])
  const [Bounty, setBounty] = useState([])
  const [VentureFund, setVentureFund] = useState([])

  const [message, setMessage] = useState('')
  const [visible, setVisible] = useState(false)

  const [Title, setTitle] = useState("");
  const [Highlight, setHighlight] = useState("");
  const [Deadline, setDeadline] = useState(new Date());
  const [Funds, setFunds] = useState("");
  const [Focus_Area, setFocus] = useState("");
  const [Type, setType] = useState("");
  const [Apply, setwebapply] = useState("");
 
const [error, setError] = useState('')
const [dbValues, setUpdateC] = useState('')


  const onFinish = values => {
      const data = {
        Title,  
        Highlight, 
        Deadline, 
        Funds,
        Focus_Area,  
        Type,
        Apply
      }
    console.log("Received values of form: ", data);

    if(!data) {
        
      setError("Fill Form Correctly")
      setMessage('')
    }

    else {
        Firestore.collection("updates").doc(dbValues.id)
        .update(data)
        .then(res => {
          setMessage("Updates successfully added")
        })
        .catch(error => {
          throw error;
        });
    }
  };
  
  useEffect(() => {
    async function fetchUpdates() {
      Firestore.collection("updates")
        .get()
        .then(function(querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function(doc) {
            docs.push({ ...doc.data(), id: doc.id });
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setData(docs);
            }, 1000);
          });
        });


        Firestore.collection("updates").where("Type", "==", "Accelerator")
        .get()
        .then(function(querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function(doc) {
            docs.push(doc.data());
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setaccelerator(docs);
            }, 1000);
          });
        });

        Firestore.collection("updates").where("Type", "==", "Crypto Fund")
        .get()
        .then(function(querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function(doc) {
            docs.push(doc.data());
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setCrypto(docs);
            }, 1000);
          });
        });

        Firestore.collection("updates").where("Type", "==", "Grants")
        .get()
        .then(function(querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function(doc) {
            docs.push(doc.data());
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setGrant(docs);
            }, 1000);
          });
        });


        Firestore.collection("updates").where("Type", "==", "Venture Fund")
        .get()
        .then(function(querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function(doc) {
            docs.push(doc.data());
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setVentureFund(docs);
            }, 1000);
          });
        });


        Firestore.collection("updates").where("Type", "==", "Bounty")
        .get()
        .then(function(querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function(doc) {
            docs.push(doc.data());
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setBounty(docs);
            }, 1000);
          });
        });



        Firestore.collection("updates").where("Type", "==", "Venture Fund")
        .get()
        .then(function(querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function(doc) {
            docs.push(doc.data());
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setVentureFund(docs);
            }, 1000);
          });
        });

        Firestore.collection("updates").where("Type", "==", "Hackathon")
        .get()
        .then(function(querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function(doc) {
            docs.push(doc.data());
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setHackathon(docs);
            }, 1000);
          });
        });


        
    }

    fetchUpdates();
  }, []);


  const handleOnChange = (e, data) => {
    console.log(data.value);
    setType(data.value)
    console.log('Type', Type);
 }


  const columns = [
    {
      title: 'Title',
      dataIndex: 'Title',
      key: 'Title',
    },
    {
      title: 'Type',
      dataIndex: 'Type',
      key: 'Type',
    },
    {
      title: 'Highlight',
      dataIndex: 'Highlight',
      key: 'Highlight',
    },
    {
      title: 'Deadline',
      dataIndex: 'Deadline',
      key: 'Deadline',
      render: (index) => (
        <>
        {index == '' ?  'Ongoing' : index}
        </>
      )
    },
    {
      title: 'Funds',
      dataIndex: 'Funds',
      key: 'Funds',
    },
    {
      title: 'Focus_Area',
      dataIndex: 'Focus_Area',
      key: 'Focus_Area',
    },
  
    {
      title: 'Action',
      key: 'Apply ',
      render: (index) => (
       <>
            <Button
                className="btn-sm mt-2"
                outline
                color="info"
                onClick={() => showDrawer(index.id)}
            >
                Edit
            </Button>

             <Button
                className="btn-sm mt-2"
                outline
                color="danger"
                onClick={() => DeleteUpdate(index)}
            >
                Delete
            </Button>
       </>
      ),
    },
  ];



  const showDrawer = (index) => {
   console.log(index)
   setVisible(true)
    
   Firestore.collection("updates")
      .doc(index)
      .get()
      .then(doc => {
        setUpdateC({...doc.data, id: doc.id })

        setTitle(doc.data().Title);
        setHighlight(doc.data().Highlight);
        setDeadline(doc.data().Deadline);
        setFunds(doc.data().Funds);
        setFocus(doc.data().Focus_Area);
        setType(doc.data().Type);
        setwebapply(doc.data().Apply);
      });
  };

const onClose = () => {
    setVisible(false)
  };

  const options = [
    { key: 'venture fund', text: 'venture fund', value: 'venture fund'},
    { key: 'Accelerator', text: 'Accelerator', value: 'Accelerator'},
    { key: 'Crypto Fund', text: 'Crypto Fund', value: 'Crypto Fund'},
    { key: 'Grants', text: 'Grants', value: 'Grants'},
    { key: 'Bounty', text: 'Bounty', value: 'Bounty'},
    { key: 'Hackathon', text: 'Hackathon', value: 'Hackathon'},
 ]

  const DeleteUpdate = (item) => {
      console.log(item)
    Firestore.collection("updates").doc(item.id).delete().then(function() {
       setMessage("Item delete successfully")
        Firestore.collection("updates")
        .get()
        .then(function(querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function(doc) {
            docs.push({ ...doc.data(), id: doc.id });
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setData(docs);
            }, 1000);
          });
        });

    }).catch(function(error) {
        console.error("Error removing document: ", error);
    });
  }
  
  return (
 
        <>
        
            <Card className="mb-3">
              <CardContent>
              {message === '' ? '' : <Alert>{message}</Alert>}
             
                <Tabs defaultActiveKey="1">
                  <TabPane tab={<span>All</span>} key="1">
                    <Table columns={columns} dataSource={data.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Venture Fund</span>} key="2">
                  <Table columns={columns} dataSource={VentureFund.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Accelerator</span>} key="3">
                         <Table columns={columns} dataSource={accelerator.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Crypto Fund</span>} key="4">
                    <Table columns={columns} dataSource={Crypto.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Grants</span>} key="5">
                    <Table columns={columns} dataSource={Grants.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Bounty</span>} key="6">
                      <Table columns={columns} dataSource={Bounty.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Hackathon</span>} key="66">
                    <Table columns={columns} dataSource={Hackathon.reverse()} />
                  </TabPane>

              
                  
                </Tabs>
              </CardContent>
            </Card>


            <Drawer
              title="Edit Updates"
              placement="right"
              closable={false}
              onClose={onClose}
              visible={visible}
            >
                  {message === '' ? '' : <Alert>{message}</Alert>}
           {error === '' ? '' : <Alert color={"danger"}>{error}</Alert>}
               <Form
            name="normal_login"
            className="login-form"
            initialValues={{ remember: true }}
          >
            <Row>
              <Col md={12} lg={12} sm={12}>
                <label>Title</label>
                <Form.Item
                  name="Title"
                  rules={[
                    { required: true, message: "Please input your Title" }
                  ]}
                >
                  <Input allowClear 
                    prefix={<UserOutlined className="site-form-item-icon" />}
                   value={Title} placeholder={Title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col md={12} lg={12} sm={12}>
                <label>Highlight</label>
                <Form.Item
                  name="Highlight"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Highlight line"
                    }
                  ]}
                >
                  <Input allowClear 
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    value={Highlight} placeholder={Highlight}
                    onChange={e => setHighlight(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col md={12} lg={12} sm={12}>
                <label>Deadline</label>
                <Form.Item
                  name="Deadline"
                  rules={[
                    { required: true, message: "Please input your Deadline" }
                  ]}
                >
                
                  <Input type='date'
                  style={{width: '100%'}}
                    onChange={e => setDeadline(e.target.value)}
                  />
                   
                </Form.Item>
              </Col>

              <Col md={12} lg={12} sm={12}>
                <label>Funds</label>
                <Form.Item
                  name="Funds"
                  rules={[
                    { required: true, message: "Please input your Funds" }
                  ]}
                >
                  <Input allowClear 
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    value={Funds} placeholder={Funds}
                    onChange={e => setFunds(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col md={12} lg={12} sm={12}>
                <label>Focus Area</label>
                <Form.Item
                  name="Focus Area"
                  rules={[
                    { required: true, message: "Please input your Focus Area" }
                  ]}
                >
                  <Input allowClear 
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    value={Focus_Area} placeholder={Focus_Area}
                    onChange={e => setFocus(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col md={12} lg={12} sm={12}>
               <label>Type</label>   
              <Dropdown 
              onChange={handleOnChange} fluid 
              multiple selection options={options}
              placeholder={Type} />

              </Col>

              <Col md={12} lg={12} sm={12}>
                <label>Website Link</label>
                <Form.Item
                  name="Link"
                  rules={[
                    {
                      required: true,
                      message: "Please input your website Link"
                    }
                  ]}
                >
                  <Input allowClear 
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    value={Apply}  placeholder={Apply}
                    onChange={e => setwebapply(e.target.value)}
                  />
                </Form.Item>
              </Col>


              <Col md={12} lg={12}>
                <hr />
              </Col>

              <Col md={12} lg={12} sm={12} className="text-right">
                <Button onClick={onFinish} htmlType="submit">Save</Button>
              </Col>
            </Row>
          </Form>
       
            </Drawer>
         
        </>

  );
}
